import { render, staticRenderFns } from "./PrintOrderDialog.vue?vue&type=template&id=22efe780"
import script from "./PrintOrderDialog.vue?vue&type=script&lang=ts"
export * from "./PrintOrderDialog.vue?vue&type=script&lang=ts"
import style0 from "./PrintOrderDialog.vue?vue&type=style&index=0&id=22efe780&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports